module.exports = __webpack_public_path__ + "static/media/tour_btn.44fd7d4b.svg";